import React, {Component} from 'react';
import Slider from 'react-slick';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom'
import {addToCart, addToCompare} from "../../../actions";
import { addToWishlist } from '../../../actions/wishlist'
import ProductItem from '../../layouts/common/product-item';
import CategoryProductItem  from '../../category/common/categoryProductItem'


class RelatedProduct extends Component {

    resizeRelatedProducts(length) {
        // 
        if(length <= 1)
        {
            return 'col-lg-4 col-md-6 p-0'
        }
        return length <= 2 ? 'col-lg-6 p-0' : 'col-lg-12 p-0'
    }
    

    handleAddToWishlist = (item,) => {
        const { connection_id, consumer_mobile_no } = this.props
        const options = { connection_id, consumer_mobile_no, lot_code: item.QOL_LOT_CD }
        this.props.addToWishlist(options)
    }
    

    render (){

        // console.log(this.props)
        const {type, items, symbol, addToCart, addToWishlist, addToCompare, presentURL} = this.props;

        const similarProducts = {
            infinite: false,
            dots: false,
            speed: 300,
            slidesToShow: 5,
            lazyLoad: true,
            slidesToScroll: 5,
            responsive: [
                {
                    breakpoint: 1367,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        infinite: false
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ],
        }

        if(!items && items.length < 0)
            return (
                <section className="section-b-space">
                <div className="container">
                    <div className="row">
                        <div className="col-12 product-related">
                            <h4>no related products found</h4>
                        </div>
                    </div>
                </div>
            </section>
            )
            
        return (
            <section className={ 'section-b-space csa-product-details' }>
            <div className="container">
            <div className="row">
                         <div className="col-12 product-related">
                            <h2 style={{textTransform: "uppercase"}}>related products</h2>
                        </div>
                     </div>
                <div className="row">
                    <div className={this.resizeRelatedProducts(items && items.length) || 'col-12'}>
                    {/* <div className="col-12 p0"> */}
                        <Slider {...similarProducts} 
                        
                        className="product-4 product-m home-slider">
                            {items.map((product, index) => {
                                // if(index < 6)
                                return (
                                    <div key={index}>
                                        <CategoryProductItem product={product} symbol={symbol}
                                            onAddToCompareClicked={() => addToCompare(product)}
                                            onAddToWishlistClicked={() => this.handleAddToWishlist(product)}
                                            onAddToCartClicked={() => addToCart(product, 1)} key={index} 
                                            presentURL={presentURL}
                                            related = 'yes'
                                            />
                                    </div>)
                            })
                            }
                        </Slider>
                    </div>
                </div>
            </div>
        </section>
        )
    }
}

function mapStateToProps(state) {
    return {
        symbol: state.data.symbol
    }
}

export default connect(mapStateToProps, {addToCart, addToWishlist, addToCompare})(RelatedProduct);
